import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import { intlMessage } from 'constants/propTypes';
import { bem } from 'helpers/class-name';
import Message from 'components/Message';
import './InputLabel.scss';

const messages = defineMessages({
  required: {
    id: 'components.form.input-label.required',
    defaultMessage: 'Required',
  },
  optional: {
    id: 'components.form.input-label.optional',
    defaultMessage: 'Optional',
  },
});

const { block, element } = bem('input-label');

function InputLabel(props) {
  const { message, required, optional, name, className, children } = props;

  if (!message && !children && !required && !optional) return null;

  let metaMessage;
  if (required) {
    metaMessage = messages.required;
  } else if (optional) {
    metaMessage = messages.optional;
  }

  return (
    <label className={block(className)} htmlFor={name}>
      {message && <Message message={message} />}
      {children}
      {!!metaMessage && <Message className={element('meta')} message={metaMessage} />}
    </label>
  );
}

InputLabel.defaultProps = {
  name: '',
  className: '',
};

InputLabel.propTypes = {
  message: intlMessage,
  name: PropTypes.string,
  required: PropTypes.bool,
  optional: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default InputLabel;
